import { SelectedWorkspaceCtx } from "../../contexts/SelectedWorkspaceCtx";
import { ProfileDropdown } from "../my-account/ProfileDropdown";

export function AppHeaderNav() {
  const children = {
    profileDropdown: ProfileDropdown()
  };

  function updateHeaderNavTitle(title: string) {
    const headerNavTitleElem = document.getElementById("header-nav-title");

    if (headerNavTitleElem) {
      if(title === "Settings"){
        headerNavTitleElem.innerText = SelectedWorkspaceCtx.selectedWorkspace?.name ?? "Settings";
        return;
      }
      headerNavTitleElem.innerText = title;
    } else {
      console.error("Couldn't find the Header Nav Title element!");
    }
  }

  function render() {
    return /*html*/`
    <header
      class="lg:ms-[260px] fixed flex-col top-0 inset-x-0 flex flex-wrap md:justify-start md:flex-nowrap z-50 bg-white border-b border-gray-200 dark:bg-neutral-800 dark:border-neutral-700">
      <div class="flex justify-between lg:grid lg:grid-cols-3 basis-full items-center w-full py-2.5 px-2 sm:px-5">
        <div class="flex items-center gap-x-3">
          <!-- Heading -->
          <div class="flex items-center gap-x-2.5 hidden md:flex">
            <span id="header-nav-title" class="text-lg font-semibold text-gray-800 dark:text-white">
              Feedspace
            </span>
          </div>
          <!-- End Heading -->

          <div class="lg:hidden">
            <!-- Sidebar Toggle -->
            <button type="button"
              class="w-7 h-[36px] inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-800 dark:border-neutral-700 dark:text-neutral-300 dark:hover:bg-neutral-700 dark:focus:bg-neutral-700"
              aria-haspopup="dialog" aria-expanded="false" aria-controls="hs-pro-sidebar" aria-label="Toggle navigation"
              data-hs-overlay="#hs-pro-sidebar">
              <svg class="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17 8L21 12L17 16M3 12H13M3 6H13M3 18H13" />
              </svg>
            </button>
            <!-- End Sidebar Toggle -->
          </div>
        </div>

        <div class="hidden lg:block lg:w-full lg:mx-0"></div>

        <div class="flex justify-end items-center gap-x-2">
          <div class="flex items-center">
            <!-- Help Dropdown -->
            <div class="hs-dropdown [--placement:bottom-right] relative inline-flex">
              <!-- Help Button Icon -->
              <div class="inline-block">
                <button id="hs-pro-dnhd" type="button"
                  class="size-[36px] inline-flex justify-center items-center gap-x-2 rounded-full border border-transparent text-gray-500 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:focus:bg-neutral-700"
                  aria-haspopup="menu" aria-expanded="false" aria-label="Dropdown">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info shrink-0 size-4"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
                  
                </button>

              </div>
              <!-- End Help Button Icon -->

              <!-- Help Dropdown -->
              <div
                class="hs-dropdown-menu hs-dropdown-open:opacity-100 w-60 transition-[opacity,margin] duration opacity-0 hidden z-10 bg-white rounded-xl shadow-[0_10px_40px_10px_rgba(0,0,0,0.08)] dark:shadow-[0_10px_40px_10px_rgba(0,0,0,0.2)] dark:bg-neutral-900"
                role="menu" aria-orientation="vertical" aria-labelledby="hs-pro-dnhd">
                <div class="p-1">
                  <!----- <a class="flex gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
                    href="https://help.feedspace.io/en/category/faqs-yf60ha/?utm_source=app&utm_medium=faq&utm_campaign=help+section"
                    target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-message-circle-question">
                      <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
                      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                      <path d="M12 17h.01" />
                    </svg>
                    FAQs
                  </a> ---->
                  <a class="flex gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
                    href="https://help.feedspace.io/en/category/tutorials-1uf70pn/?utm_source=help-section&utm_medium=homepage&utm_campaign=tutorials-in-the-help-section"
                    target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-tv-minimal-play">
                      <path
                        d="M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z" />
                      <path d="M7 21h10" />
                      <rect width="20" height="14" x="2" y="3" rx="2" />
                    </svg>
                    Tutorials
                  </a>
                  <a class="flex gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
                    href="javascript:void(0);" data-feedspace="L9N1NvEBJJdw67nB">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-lightbulb">
                      <path
                        d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                      <path d="M9 18h6" />
                      <path d="M10 22h4" />
                    </svg>
                    Request a Feature
                  </a>

                  <a class="flex gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
                    href="javascript:void(0);" data-feedspace="RMJnqezO0YPlzo0g">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-message-circle-more">
                      <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
                      <path d="M8 12h.01" />
                      <path d="M12 12h.01" />
                      <path d="M16 12h.01" />
                    </svg>
                    Give us a Feedback
                  </a>
                  <a class="flex gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
                    href="https://www.feedspace.io/contact/?utm_source=app&utm_medium=contact+us&utm_campaign=help+section"
                    target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-at-sign">
                      <circle cx="12" cy="12" r="4" />
                      <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8" />
                    </svg>
                    Contact Us
                  </a>

                  <div class="my-1 border-t border-gray-200 dark:border-neutral-800"></div>


                  <a class="flex gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
                    href="https://feedspacecommunity.slack.com/join/shared_invite/zt-nr9oq7ud-UkUtpqigIzW9fPNDmBZ8ug#/shared-invite/email"
                    target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-slack">
                      <rect width="3" height="8" x="13" y="2" rx="1.5" />
                      <path d="M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5" />
                      <rect width="3" height="8" x="8" y="14" rx="1.5" />
                      <path d="M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5" />
                      <rect width="8" height="3" x="14" y="13" rx="1.5" />
                      <path d="M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5" />
                      <rect width="8" height="3" x="2" y="8" rx="1.5" />
                      <path d="M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5" />
                    </svg>
                    Join Slack Community
                  </a>
                  <!--- <a class="flex gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
                    href="https://x.com/getfeedspace" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                      <path fill="currentColor"
                        d="m17.687 3.063l-4.996 5.711l-4.32-5.711H2.112l7.477 9.776l-7.086 8.099h3.034l5.469-6.25l4.78 6.25h6.102l-7.794-10.304l6.625-7.571zm-1.064 16.06L5.654 4.782h1.803l10.846 14.34z">
                      </path>
                    </svg>
                    Find us on Twitter
                  </a> -->
                  <!--- <a class="flex gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
                    href="https://www.linkedin.com/company/getfeedspace" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-linkedin">
                      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                      <rect width="4" height="12" x="2" y="9" />
                      <circle cx="4" cy="4" r="2" />
                    </svg>
                    Find us on LinkedIn
                  </a> --->
                  <!--- <a class="flex gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
                    href="https://www.instagram.com/getfeedspace" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-instagram">
                      <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
                    </svg>
                    Find us on Instagram
                  </a> --->
                </div>
              </div>
              <!-- End Help Dropdown -->
            </div>
            <!-- End Help Dropdown -->

            <!-- Notifications Button Icon -->
            <!-- End Notifications Dropdown -->
            
            <!-- Activity Button Icon -->
            <!-- <div class="hs-tooltip [--placement:bottom] inline-block">
              <button
                type="button"
                class="hs-tooltip-toggle size-[38px] inline-flex justify-center items-center gap-x-2 rounded-full border border-transparent text-gray-500 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-100 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:focus:bg-neutral-700"
                data-hs-overlay="#hs-pro-dnam"
              >
                <svg
                  class="shrink-0 size-3.5"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                </svg>
              </button>
              <span
                class="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 inline-block absolute invisible z-20 py-1.5 px-2.5 bg-gray-900 text-xs text-white rounded-lg dark:bg-neutral-700"
                role="tooltip"
              >
                Activity
              </span>
            </div> -->
            <!-- End Activity Button Icon -->
          
          </div>

          <!--- <div>
            <button class="btn btn-sm btn-white">Add New</button>
          </div> --->

          <!-- Invite Users -->
          <!-- End Invite Users -->

          ${children.profileDropdown.render()}
        </div>
      </div>
    </header>
    `;
  }

  return { render, updateHeaderNavTitle, children };
}